import React from "react";
import { connect } from "react-redux";
import constants from "common/constants";
import messages from "utils/messages";
import Switch from "react-switch";
import Icon from "components/Icon/Icon";
import { changeTheme } from "actions/theme";
import { showModal } from "actions/modal";
import { subDays, format } from "date-fns";
import DropdownButton from "react-bootstrap/lib/DropdownButton";
import MenuItem from "react-bootstrap/lib/MenuItem";
import { LinkContainer } from "react-router-bootstrap";

class Header extends React.Component {
  changeTheme() {
    if (!this.props.user.isPremium && this.props.variables.theme !== "dark") {
      this.props.dispatch(
        showModal("premiumFeature", {
          class: "premiumfeature",
          type: "darkmode",
        })
      );
    }
    this.props.dispatch(changeTheme());
  }

  showAddGroupForm() {
    if (this.props.user.isPremium) {
      this.props.dispatch(
        showModal("editGroup", {
          title: messages.ADD_GROUP,
        })
      );
    } else {
      this.props.dispatch(
        showModal("subscription", {
          showBrightModal: true,
          class: "premium",
          origin: "AddGroupUpgradeModal",
        })
      );
    }
  }

  renderRow() {
    const row = [];
    const groups = this.props.groups;

    let numDaysView = this.props.numDaysView;
    let offset = this.props.offset;
    if (constants.numDays - numDaysView + 1 === offset) {
      offset++;
      numDaysView--;
    }

    for (let i = 1; i <= numDaysView; i++, offset++) {
      const currentDate = subDays(
        this.props.currentDay,
        constants.numDays - offset
      );
      const month = format(currentDate, "MMM");
      const date = format(currentDate, "D");
      const day = format(currentDate, "ddd");
      let className = "";
      if (day === "Sat" || day === "Sun") {
        className += " weekend";
      }
      if (offset === constants.numDays) {
        className += " today";
        row.push(
          <td key={i} className={className}>
            <div className="circle">
              <div className="month">{month}</div>
              <div className="date">
                <div>{date}</div>
              </div>
              <div className="day">{day}</div>
            </div>
          </td>
        );
      } else {
        row.push(
          <td key={i} className={className}>
            <div>
              <div className="month">{month}</div>
              <div className="date">{date}</div>
              <div className="day">{day}</div>
            </div>
          </td>
        );
      }
    }

    return <tr>{row}</tr>;
  }

  renderGroupsMenu() {
    const title =
      this.props.boardFilter.groupId === null
        ? messages.ALL_HABITS
        : this.props.groups.find(
            (group) => group.id === this.props.boardFilter.groupId
          ).name;

    return (
      <DropdownButton
        onClick={(e) => e.stopPropagation()}
        title={title}
        id="habitsMenu"
        className="habits-dropdown"
      >
        <MenuItem
          className="group-filter-item"
          onClick={() =>
            this.props.dispatch({
              type: "SET_BOARD_FILTER",
              groupId: null,
            })
          }
        >
          {messages.ALL_HABITS}
        </MenuItem>
        <MenuItem divider />
        {this.props.groups.map((group) => (
          <MenuItem
            className="group-filter-item"
            onClick={() =>
              this.props.dispatch({
                type: "SET_BOARD_FILTER",
                groupId: group.id,
              })
            }
            key={group.id}
          >
            {group.name}
          </MenuItem>
        ))}
        {this.props.groups.length > 0 && <MenuItem divider />}
        <MenuItem onClick={() => this.showAddGroupForm()}>
          {messages.ADD_GROUP}
        </MenuItem>
      </DropdownButton>
    );
  }

  render() {
    return (
      <div className="header" style={{}}>
        {this.props.controlPanel.isVisible ? (
          <div className="controlpanel-header">
            <div className="cp-header-row"></div>
            <div className="cp-header-row">
              <div className="control-block">
                <Icon
                  onClick={() => this.showAddGroupForm()}
                  className="controlpanel-icon newgroup"
                  name="FolderAdd"
                  color="var(--main-dark)"
                />
              </div>
              <div className="control-block"></div>
              <div className="control-block"></div>
              {/*              <div className="control-block">
                <Icon
                  className="controlpanel-icon"
                  name="Bell"
                  color="var(--main-font-color)"
                />
              </div>
              <div className="control-block">
                <Icon
                  className="controlpanel-icon"
                  name="Time"
                  color="var(--main-font-color)"
                />
              </div>*/}
            </div>
          </div>
        ) : null}
        <div className="left">
          <div className="prev">
            <Icon
              name="ControlsAlt"
              color="var(--main-dark)"
              onClick={() =>
                this.props.dispatch({ type: "TOGGLE_CONTROL_PANEL" })
              }
            />
            <i onClick={this.props.prevDates} className="ion-ios-arrow-back" />
          </div>
          <div className="filter">{this.renderGroupsMenu()}</div>
        </div>
        <div className="dates">
          <table>
            <tbody>{this.renderRow()}</tbody>
          </table>
        </div>
        <div className="right">
          <div className="next" onClick={this.props.nextDates}>
            <i className="ion-ios-arrow-forward" />
            <div className="dark-mode-switch-board">
              <Icon
                className="dark-mode-icon-board"
                name="Brightness"
                color="var(--main-dark)"
              />
              <Switch
                className="da"
                height={15}
                width={30}
                uncheckedIcon={false}
                checkedIcon={false}
                onChange={this.changeTheme.bind(this)}
                checked={this.props.variables.theme === "dark"}
              />
            </div>
          </div>
          {this.props.statsType === 1 ? (
            <div className="titles">
              <a>{messages.CURRENT_STREAK}</a>
              <a>{messages.LONGEST_STREAK}</a>
              <a>{messages.TOTAL_COUNT}</a>
            </div>
          ) : null}
          {this.props.statsType === 2 ? (
            <div className="titles">
              <a>{messages.ST_WEEK_COUNT}</a>
              <a>{messages.ST_MONTH_COUNT}</a>
              <a>{messages.ST_YEAR_COUNT}</a>
            </div>
          ) : null}
          {this.props.statsType === 3 ? (
            <div className="titles extraline">
              <a>{messages.ST_WEEK_COMPL_RATE}</a>
              <a>{messages.ST_MONTH_COMPL_RATE}</a>
              <a>{messages.ST_YEAR_COMPL_RATE}</a>
            </div>
          ) : null}
        </div>
        <div className="clear" />
      </div>
    );
  }
}

export default connect((state) => {
  return {
    variables: state.variables,
    user: state.user,
    groups: state.rows
      .filter((row) => row.isGroup)
      .filter((row) => row?.id)
      .map((row) => state.groupsEntities[row.id] || {}),
    controlPanel: state.controlPanel,
    boardFilter: state.boardFilter,
    filterBorderColor: state.boardFilter.groupId
      ? state.groupsEntities[state.boardFilter.groupId].color
      : "transparent",
  };
})(Header);
